export const fadeIn = ( el, ms, params = {} ) => {
	const defaults = { from : 0 };
	const options = Object.assign( {}, defaults, params );

	fade( el, 100, ms, options );
};

export const fadeOut = ( el, ms, params = {} ) => {
	fade( el, 0, ms, params );

	el.addEventListener( 'transitionend', () => {
		el.style.display = 'none';
	}, { once : true } );
};

export const fade = ( el, to, ms, params = {} ) => {
	const defaults = { callback : null };
	const options = Object.assign( {}, defaults, params );

	if ( options.hasOwnProperty( 'from' ) ) {
		el.style.opacity = options.from;
	}

	el.style.display = 'block';
	el.style.transition = `all ${ms}ms`;

	setTimeout( () => {
		el.style.opacity = to;
	}, 0 );

	el.addEventListener( 'transitionend', () => {
		el.style.transition = null;
		if ( options.hasOwnProperty( 'callback' ) && options.callback !== null ) {
			options.callback();
		}
	}, { once : true } );

};